import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ContentComponent } from "./shared/components/layout/content/content.component";
import { FullComponent } from "./shared/components/layout/full/full.component";
import { full } from "./shared/routes/full.routes";
import { content } from "./shared/routes/routes";
import {AdminGuard} from './shared/guard/admin.guard'

const routes: Routes = [
  {
    path: "",
    component: ContentComponent,
    canActivate: [AdminGuard],
    children: content
  },
  
  {
    path: "",
    redirectTo: "auth/login",
    pathMatch: "full"
  },
  {
    path: "auth/login",
    loadChildren: () => import("../app/auth/login/login.module").then((m) => m.LoginModule)
  },
  {
    path: "auth/select-organization",
    loadChildren: () => import("../app/auth/select-organization/select-organization.module").then((m) => m.SelectOrganizationModule)
  },
  {
    path: "auth/select-language",
    loadChildren: () => import("../app/auth/select-language/select-language.module").then((m) => m.SelectLanguageModule)
  },
  {
    path: "auth/reset-password",
    loadChildren: () => import("../app/auth/reset-password/reset-password.module").then((m) => m.ResetPasswordModule)
  },
  {
    path: "",
    component: FullComponent,
    children: full
  },
  {
    path: "**",
    redirectTo: "auth/login"
  },
];

@NgModule({
  imports: [
    [
      RouterModule.forRoot(routes, {
        anchorScrolling: "enabled",
        scrollPositionRestoration: "enabled"
      })
    ],
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
